import { Ifield } from '../types';
import { FormControl, Select, MenuItem, FormHelperText, InputLabel } from '@mui/material';
import { getErrorText } from '..';
import { CustomSelect } from '../../../theme/elements/Inputs';
import React from 'react';

type props = {
	valid: boolean;
	cField: Ifield;
	initialValidation: any;
	handleChange: any;
};

export const SelectBox = (props: props) => {
	const { valid, cField, handleChange, initialValidation } = props;
	const { name, value, label, placeholder, options, required } = cField.props;
	return (
		<FormControl error={!valid} fullWidth sx={cField.styleObj}>
			<CustomSelect key={name}>
				<InputLabel id="country-label">
					{label}
					{required ? ' *' : ''}
				</InputLabel>
			</CustomSelect>
			<Select
				{...cField.props}
				error={!valid}
				label={label}
				name={name}
				value={value || ''}
				onChange={handleChange}
				placeholder={placeholder}
			>
				{options?.map((option: any, idx) => {
					const val = cField.valueProperty ? option[cField.valueProperty] : option.value;
					const lab = cField.labelProperty ? option[cField.labelProperty] : option.label;
					return (
						<MenuItem key={`select-option-${idx}`} value={val}>
							{lab}
						</MenuItem>
					);
				})}
			</Select>
			<FormHelperText error={!valid}>{getErrorText(initialValidation, name)}</FormHelperText>
		</FormControl>
	);
};
